/**
 * Frontend menu/route gating.
 *
 * Source of truth is the backend roles table — the user's allowed_tabs
 * arrive via /auth/me (and the dev-login response) and are stored on the
 * AuthUser. This module just interprets that list. Per-BAP access is
 * still enforced server-side by OPA (authz.bap).
 */

export type TabId = 'dashboard' | 'berkas' | 'analisa' | 'audit' | 'admin' | 'privacy';

/** Conservative fallback for sessions stored before allowed_tabs existed. */
const BASE_TABS: TabId[] = ['dashboard', 'berkas', 'analisa'];

export function effectiveTabs(allowed: string[] | undefined): string[] {
  return allowed && allowed.length ? allowed : BASE_TABS;
}

export function canAccessTab(allowed: string[] | undefined, tab: TabId): boolean {
  return effectiveTabs(allowed).includes(tab);
}

/** Resolve a route path to the top-level tab that owns it. */
export function tabForPath(path: string): TabId | null {
  if (path.startsWith('/dashboard')) return 'dashboard';
  if (path.startsWith('/berkas')) return 'berkas';
  if (
    path.startsWith('/analisa') ||
    path.startsWith('/tanya') ||
    path.startsWith('/ai-playground')
  ) {
    return 'analisa';
  }
  if (path.startsWith('/audit')) return 'audit';
  if (path.startsWith('/admin')) return 'admin';
  if (path.startsWith('/privacy')) return 'privacy';
  return null;
}

export function canAccessPath(allowed: string[] | undefined, path: string): boolean {
  const tab = tabForPath(path);
  if (!tab) return true;
  return canAccessTab(allowed, tab);
}
